module.exports = __webpack_public_path__ + "img/welcome.f82b44c1.svg";